import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { MarketdayComponent } from './marketday.component';
import { MarketdayDetailComponent } from './marketday-detail.component';
import { MarketdayPopupComponent } from './marketday-dialog.component';
import { MarketdayDeletePopupComponent } from './marketday-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class MarketdayResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const marketdayRoute: Routes = [
  {
    path: 'marketday',
    component: MarketdayComponent,
    resolve: {
      'pagingParams': MarketdayResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketday.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'marketday/:id',
    component: MarketdayDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketday.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const marketdayPopupRoute: Routes = [
  {
    path: 'marketday-new',
    component: MarketdayPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketday.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketday/:id/edit',
    component: MarketdayPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketday.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketday/:id/delete',
    component: MarketdayDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketday.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketday/marketday.route.ts